import React, { useCallback, useEffect, useState } from "react";
import { debounceHandler } from "utils";

function SearchBar(props) {
  const [inputText, setInputText] = useState("");

  const debounceSearch = useCallback(
    debounceHandler(value => {
      props.onChangeSearch(value);
    }, 300),
    []
  );

  useEffect(() => {
    debounceSearch(inputText);
  }, [inputText, debounceSearch]);

  return (
    <div className="container_navbar ">
      <div className="inner_container_navbar">
        <div className="main_header_title">
          {props.search ? (
            <p className="srchResult">
              <span className="back_btn" onClick={() => setInputText("")} />
              <span>Search results for "{props.search}"</span>
            </p>
          ) : (
            <p>Backup Plan</p>
          )}
        </div>
        <div className="container_navbar_right">
          <div className="number_of_computers">
            <p>
              Total Backup Plans:{" "}
              <span className="semi_strong">{props.totalMachines}</span>
            </p>
          </div>
          <div className="container_navbar_searchbox search_wrp">
            <input
              type="text"
              className="input_searchbox"
              placeholder="Search"
              onChange={e => setInputText(e.target.value)}
              value={inputText}
              maxLength={50}
            />
            {props.search && (
              <div
                className="navbar_close_btn"
                onClick={() => setInputText("")}
              ></div>
            )}

            <div className="navbar_search_btn" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default SearchBar;
